import { expVal, expValEqualsNoExposure } from '@confluence/feature-experiments';
import { query } from '@confluence/query-preloader-tools';

import { ReadTimeQuery } from './ReadTimeQuery.graphql';
import type {
	ReadTimeQuery as ReadTimeQueryType,
	ReadTimeQueryVariables,
} from './__types__/ReadTimeQuery';

type PreloadReadTimeParams = Pick<
	ReadTimeQueryVariables,
	'includeContentBody' | 'status' | 'includeMetadata'
> & {
	contentId: ReadTimeQueryVariables['contentId'];
	useCache: boolean;
};

export function preloadReadTime({
	contentId,
	includeContentBody = true,
	status,
	useCache,
}: PreloadReadTimeParams) {
	return query<ReadTimeQueryType, ReadTimeQueryVariables>({
		query: ReadTimeQuery,
		variables: {
			contentId,
			includeContentBody:
				includeContentBody ||
				!expVal('cc_complexit_fe_skip_read_time_query_content_body', 'isEnabled', false),
			includeMetadata: expValEqualsNoExposure(
				'loom_ai_script_for_confluence_page_experiment',
				'cohort',
				'variation',
			),
			status,
		},
		fetchPolicy: useCache ? 'cache-first' : 'network-only',
	});
}
